// Get the icon component in current directory with .vue extension
const requireIcons = require.context(".", false, /\.vue$/)

// Object containing all icons component import
const icons = {}

requireIcons.keys().forEach((fileName) => {
  // Get the defaul icon component export
  const iconComponent = requireIcons(fileName).default
  // Use the name of the file (without the extension) as the key in icons object
  const iconName = fileName.replace("./", "").replace(".vue", "")
  icons[iconName] = iconComponent
})

export default icons
